import { render } from "./DeviceProfileTemplateIndex.vue?vue&type=template&id=c2a7c47c"
import script from "./DeviceProfileTemplateIndex.vue?vue&type=script&lang=js"
export * from "./DeviceProfileTemplateIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__